import { InputRange } from '../../atoms'


export function InputsCals(props) {
  const { onChange, name, handleChange, selectedValue, type, values, handleUpperChange, handleLowerChange, inputFrom, inputTo, sliderRef } = props;
   
  return (
    <div className={`radio radio__${type} ${name === 'period' ? 'radio__period' : ''}`}> 
       <div className='nutrients__block widt45'>
        <label   className='radio__label font20Norm' >
          <input type="radio" value={'calories' || ''} checked={selectedValue === 'calories'} className='radio__checkbox' onChange={onChange} name='nutrients' id='calories' />
          <span className="visible-checkbox item__link"></span>
          Ограничить калорийность
        </label>
        <div className={`wrapper-1 ${selectedValue !== 'calories' ? 'wrapper-1__disabled' : ''}`}>
        <InputRange
        title='Норма калорий в сутки, ккал'
        min={1200}
        max={4000}
        step={100}  
        values={values}
        name='cals'
        disabled={selectedValue !== 'calories' ? true : false}
        className="SB-1"
        onChange={handleChange}
        handleUpperChange={handleUpperChange}
        handleLowerChange={handleLowerChange}
        inputFrom={inputFrom}
        inputTo={inputTo}
        sliderRef={sliderRef}
        />
 
      </div> 
      </div>
       <div className='nutrients__block widt45'>
         <label   className='radio__label font20Norm' >
         <input type="radio" value={'macronutrients' || ''} disabled='true' checked={selectedValue === 'macronutrients'} className='radio__checkbox nutr__disabled' onChange={onChange} name='nutrients' id='macronutrients' />
         <span className="visible-checkbox item__link"></span>
         Ограничить БЖУ 
       </label>
       <div className={`form__nutrients ${selectedValue !== 'macronutrients' ? 'wrapper-1__disabled' : ''}`}>
       <label className='form__label_nutrients font20Norm'>
         Норма белка, г
         <input
           type="number"
           id='protein'
           name='protein' 
           placeholder='0' 
           disabled={selectedValue !== 'macronutrients' ? true : false}
           value={props.values.protein}  
           className={`form__input form__input_limit font20Norm ${selectedValue !== 'macronutrients' ? 'wrapper-1__disabled' : ''}`}
           onChange={props.handleChanges} 
          />  
      </label> 
      <label className='form__label_nutrients font20Norm'>
         Норма жиров, г
         <input
           type="number"
           id='fats'
           name='fats' 
           placeholder='0' 
           value={props.values.fats} 
           disabled={selectedValue !== 'macronutrients' ? true : false}
           className={`form__input form__input_limit font20Norm`}
           onChange={props.handleChanges} 
          />  
      </label> 
      <label className='form__label_nutrients font20Norm'>
      Норма угеводов, г
         <input
           type="number"
           id='carb'
           name='carb' 
           placeholder='0' 
           value={props.values.carb} 
           disabled={selectedValue !== 'macronutrients' ? true : false}
           className={`form__input form__input_limit font20Norm`}
           onChange={props.handleChanges} 
          />  
      </label>  
  </div> 
      </div> 
     
      
    </div>
  );
  }